module.exports = __webpack_public_path__ + "img/product-example-img.78ccf791.jpg";